module.exports = __webpack_public_path__ + "static/media/AW_56_Burger_desktop_hero_en.31d9ca0e.jpg";